import { grayPaletteDark } from '../../themes/dark-colors';

export const headerDarkV2Theme = {
  backgroundColor: grayPaletteDark[0],
};
